import { type MenuItem } from '@shared/ui/menu';

import type { EntityAction } from './entity-action';

export function resolveEntityActions<T>(actions: EntityAction<T>[], entity: T): MenuItem[] {
  return actions.map((action) => ({
    ...action,
    command: action.command ? () => action.command!(entity) : undefined,
    disabled: action.disabled?.(entity),
    visible: action.visible?.(entity),
    tooltip: action.tooltip?.(entity),
  }));
}
